import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from 'redux'
import { AppReducer } from '../Components/App/Reducer/AppReducer'
import { LoginReducer } from '../Components/LoginForm/Reducer/LoginReducer'
import { LayoutReducer } from "../Components/Layouts/Reducer/LayoutReducer";
import { ExperienceReducer } from "../Components/Product/Experiences/Reducer/ExperinceReducer";
import { AiReducer } from "../Components/Product/Experiences/Reducer/AiReducer";
import { ReservationReducer } from "../Components/Reservation/Reducer/ReservationReducer";
// TODO: AdminAuth modülü yapılınca aç:
// import { AdminAuthReducer } from '../Components/AdminAuth/Reducer/AdminAuthReducer';


const reducer = combineReducers({
  Apps: AppReducer,
  Login: LoginReducer,
  Layout: LayoutReducer,
  // Product/Experience wizard state'i (ExperienceWizard state.Product okur)
  Product: ExperienceReducer,
  // AI öneri köprüsü (Assistant -> step'ler)
  ai: AiReducer,
  // Rezervasyon listesi/detay (eski frontend birebir)
  Reservation: ReservationReducer,
  // AdminAuth: AdminAuthReducer,


});

const store = configureStore({
  reducer,
})

export default store;